enum ThemeEnum {
    DARK,
    LIGHT
}

export default ThemeEnum;